import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;

 export const GetChargeDetails = async (chargeId, setIsLoading) => {
  
    const url = `${API_Payment_URL}Payment/GetCharge`;
    const data = {
      Id: chargeId,
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
   

        setIsLoading(false);
        return errorDetails;
      }

      const result = await response.json();
    
         
      setIsLoading(false);
      return result;
    } catch (error) {
      setIsLoading(false);
      
      console.error("Error", error);
      
    }
  };

  export const InitiateOneApp = async (Token, setIsLoading, setOneAppSelected) => {

    const url = `${API_Payment_URL}Payment/InitiateOneApp`;
    const data = {
      Token: Token,
    };
    setIsLoading(true);

    //var token = tokenDetails.access_token;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });


        setIsLoading(false);
        return { success: false, ...errorDetails };
      }

      const result = await response.json();

      setIsLoading(false);
      return { success: true, ...result };
    } catch (error) {
      setIsLoading(false);

      console.error("Error", error);

      // Return error object for proper error handling
      return { success: false, message: "An unexpected error occurred. Please try again." };
    }
  };